(function () {
const announcementSlider = () => {
$(".announcement-bar__slide").each(function () {
if ($(this).hasClass("slider_started")) {
return "";
}
if ($(".announcement-bar")) {
$(this).addClass("slider_started");
}
const announcementId = $(this).data("announcement-id");
const slideCount = $(this).find(".swiper-slide").length;
const announcementSwiper = new Swiper(
`.announcement-js-${announcementId}`,
{
loop: slideCount > 1,
speed: 700,
autoplay: slideCount > 1 ? { delay: 4500, disableOnInteraction: false, pauseOnMouseEnter: true } : false,
navigation: {
nextEl: `#shopify-section-${announcementId} .announcement-btn-next`,
prevEl: `#shopify-section-${announcementId} .announcement-btn-prev`,
},
}
);
});
};
announcementSlider();
document.addEventListener("shopify:section:load", function () {
announcementSlider();
});
})();
